import { useLingui } from '@lingui/react'
import { Origin, type PromotionInformation } from '@redteclab/api/clients/bully'
import { type FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { type CartControllerCartSellerDiscountV2 } from 'types/api/cart'
import { isExpandedByDefaultForTenant } from 'views/components/organisms/Cart/helper/isExpandedByDefaultForTenant'
import { hasSAEGroupSelector } from 'views/components/organisms/Cart/selectors'
import Collapsible from 'views/components/organisms/Collapsible'
import VoucherBox from 'views/components/organisms/VoucherBox'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'

type Props = {
  vouchers: CartControllerCartSellerDiscountV2[]
  promotionInformation?: PromotionInformation[]
  nonDiscountableVouchers: string[]
  position: null | string | undefined
}

const VoucherCollapsible: FC<Props> = ({
  vouchers,
  promotionInformation,
  nonDiscountableVouchers,
  position,
}) => {
  const { i18n } = useLingui()
  position = position === undefined ? 'first' : position
  const {
    publicRuntimeConfig: {
      publicConfig: { tenant },
    },
  } = useShopAndRuntimeConfig()

  const hasSAEGroup = useSelector(hasSAEGroupSelector)
  const isExpandedByDefault =
    isExpandedByDefaultForTenant(tenant) && hasSAEGroup
  const [isExpanded, setIsExpanded] = useState(isExpandedByDefault)

  useEffect(() => {
    if (!hasSAEGroup) {
      setIsExpanded(false)
    }
  }, [hasSAEGroup])

  const vouchersWithoutAutomaticPromotions = vouchers.filter(
    voucher => voucher.origin !== Origin.Mirakl
  )

  return (
    <Collapsible
      id="voucher-collapsible"
      label={i18n._('voucherBox.button.label.redeem')}
      position={position}
      allScreensizes
      light
      forceDisplayWhenCollapsed
      expanded={isExpanded}
      disabled={!hasSAEGroup}
      handleClick={() => {
        setIsExpanded(!isExpanded)
      }}
    >
      {isExpanded && (
        <VoucherBox
          vouchers={vouchersWithoutAutomaticPromotions}
          promotionInformation={promotionInformation}
          nonDiscountableVouchers={nonDiscountableVouchers}
        />
      )}
    </Collapsible>
  )
}

export default VoucherCollapsible
